<div mat-dialog-content style="width: 400px">
  <lemon-dialog-header> Muokkaa tiedostoa: {{ fileName }} </lemon-dialog-header>

  <form>
    <div style="margin: 2rem">
      @if (!onAutomaationLuoma) {
        <mat-form-field style="width: 100%" floatLabel="always">
          <mat-label>Tilikausi</mat-label>
          <mat-select [formField]="lomake.tilikausiAvaimet" multiple placeholder="Kaikki tilikaudet">
            @for (tk of tilikaudet; track tk) {
              <mat-option [value]="tk.avain"> {{ tk.alkaa | lokaalipvm | async }} – {{ tk.loppuu | lokaalipvm | async }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (!onAutomaationLuoma) {
        <mat-form-field style="width: 100%">
          <mat-label>Tyyppi</mat-label>
          <mat-select [formField]="lomake.tiedostoTyyppi">
            @for (tyyppi of kayttajanTiedostotyypit; track tyyppi) {
              <mat-option [value]="tyyppi.arvo">
                {{ tyyppi.nimi }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field style="width: 100%">
        <mat-label>Lisätiedot</mat-label>
        <input [formField]="lomake.lisatiedot" matInput data-lpignore="true" />
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <app-secondary-button mat-dialog-close actionId="Peruuta (arkiston muokkausdialogi)" styles="margin-right: 20px;">Peruuta</app-secondary-button>
  <app-primary-button (click)="save()" actionId="Tallenna arkistotiedoston muutokset">Tallenna</app-primary-button>
</div>
